export const environment = {
	production: false,
	HOST: 'https://apidev.heydiag-rdv.fr',
	ROOT_FILE_UPLOADS: 'https://apidev.heydiag-rdv.fr/views/upload/files_upload/',
	stripe_public_key: "pk_test_FXSpRsGJ8EQqLcu0YuSy1uV4",
};
